import { render } from "./KakaoManagement.vue?vue&type=template&id=f4f32e5a"
import script from "./KakaoManagement.vue?vue&type=script&lang=js"
export * from "./KakaoManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__